module.exports = __webpack_public_path__ + "static/logo-754fe17fea9bb4d9656812c6a252cf8b.png";